<template>
  <div>
    <v-container>
      <CRUDList
        ref="crudList"
        :canAdd="canAddToSharedList"
        :canEdit="true"
        :canSave="canEditSharedList"
        :headers="headers"
        :baseCrudKey="baseCrudKey"
        :defaultSortBy="sortBy"
        :showSelect="false"
        :canDeleteInDialog="true"
        :enableFixedHeaders="true"
        :displayTopPagination="false"
        :dialogHeaderName="dialogHeaderName"
        :tableTitle="dialogHeaderName"
        dialogDynamicWidth="20vw"
        tableWrapperDynamicClassname='elevation-3 ma-3 pt-0 pa-1 taxroll-table-wrapper'
        tableDynamicClassname='taxroll-custom-table'
        tableDynamicHeight='450'
        @deleteItem="deleteFromDiaglog"
        @loadCRUDList="handleLoadCRUDList"
        @upsertItem="upsrtTransaction"
        :loadingData="gridLoading.flag"
        :loadingText="gridLoading.text"
      >
        <template v-slot:[`editedItem`]="{}">
          <taxReasonCodeEditItem :baseCrudKey="baseCrudKey" />
        </template>
      </CRUDList>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import taxReasonCodeEditItem from './taxReasonCodeEditItem.vue';
import { defaultGridLoading, manageGridLoading } from '../../../util/shared/vue-global';
import SharedListAccessControlMixin from '../SharedListAccessControl.mixin';

const getHeaders = () => {
  const headers = [
    { text: 'Reason code', value: 'reasonCode' },
    { text: 'Description', value: 'description' },
  ];
  return headers;
};

export default {
  name: 'taxReasonCode',
  mixins: [SharedListAccessControlMixin],
  components: {
    CRUDList,
    taxReasonCodeEditItem,
  },
  data: () => ({
    baseCrudKey: 'sharedTaxReasonCodes',
    headers: getHeaders(),
    dialogHeaderName: 'Reason code',
    gridLoading: defaultGridLoading(),
    sortBy: [
      {
        column: 'reasonCode',
        direction: 'asc',
      },
    ],
  }),
  created() {
    this.initCriteria();
  },
  methods: {
    ...mapActions('shared/taxReasonCode', [
      'loadReasonCode',
      'upsertTaxReasonCode',
      'deleteTaxReasonCode',
    ]),
    ...mapMutations('base/crud', ['setCriteria']),
    async upsrtTransaction(item) {
      const { baseCrudKey } = this;
      const updatedItem = { ...item };
      await this.upsertTaxReasonCode({ item: updatedItem, baseCrudKey });
    },
    handleLoadCRUDList() {
      manageGridLoading(this, true, 'Searching...');
      const { baseCrudKey } = this;
      const criteria = { ...this.criteriaState };
      this.loadReasonCode({
        criteria,
        baseCrudKey,
      }).finally(() => {
        manageGridLoading(this, false);
      });
    },
    initCriteria() {
      this.criteriaState = {};
    },
    deleteFromDiaglog(item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        const { baseCrudKey } = this;
        this.deleteTaxReasonCode({ item, baseCrudKey });
      }
    },
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'index', 'item']),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
  },
};
</script>
